// Tijden van de kaart "Verkopen gemist". Die staan hier en niet in de CSS,
// want de kaart duurt langer naarmate er meer verkopen op staan: elke regel
// komt apart binnen, en pas als de laatste staat gaat hij weer weg. De CSS
// krijgt de duur en de vertraging per regel als inline stijl mee.

// De kop (kicker, titel, "sinds ...") schuift in de eerste seconde binnen;
// daarna elke regel om de beurt.
export const rowStartMs = 1100;
export const rowStepMs = 1000;

// Na de laatste regel: het totaal, even laten staan, en dan weg.
export const totalAfterMs = 500;
export const holdMs = 3200;
export const outMs = 600;

// Is er niets verkocht, dan staat er geen lijst die de kaart vanzelf lang
// genoeg op het scherm houdt. Zonder deze extra tijd is de kaart weg voor
// je hem van de andere kant van de ruimte gelezen hebt.
export const emptyHoldMs = 2200;

// Meer regels dan dit passen niet onder de titel. Daarboven worden de
// kleinste verkopen één regel "en nog N verkopen".
export const maxRows = 5;

export function rowCount(saleCount) {
  return Math.min(saleCount, maxRows);
}

// Wanneer regel i verschijnt, vanaf het begin van de kaart.
export function rowDelayMs(index) {
  return rowStartMs + index * rowStepMs;
}

export function missedSalesMs(saleCount) {
  const rows = rowCount(saleCount);
  const lastRow = rows ? rowDelayMs(rows - 1) : rowStartMs;
  const extra = rows ? 0 : emptyHoldMs;
  return lastRow + totalAfterMs + holdMs + outMs + extra;
}
